import AppContext from "AppContext";
import { confirm } from "components/Confirmation";
import CustomDropzone from "components/CustomDropzone";
import { hideLoading } from "components/Loading";
import { showLoading } from "components/Loading";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody } from "reactstrap";
import ordemServicoService from "services/OrdemServicoService";

export function ModalIncluir({ config, onClosed, onChange }) {
  const [data, setData] = useState([])
  const { state } = useContext(AppContext)


  const handleChange = (field, value) => {
    setData({ ...data, [field]: value })
  }

  const handleSubmit = (ev) => {
    ev.preventDefault()

    confirm({
      header: "Importação",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          showLoading()
          const res = await ordemServicoService.import(state.contrato.id, data.planilha)
          hideLoading()
          if (res.success) {
            toast("A planilha foi importada com sucesso!")
            onChange && onChange()
            onClosed && onClosed()
          } else {
            toast("Erro ao importar a planilha")
          }
        } catch (ex) {
          hideLoading()
          if (ex.status == 422 || ex.status == 400) {
            toast(ex.response.data.message || "Erro ao importar a planilha")
          } else {
            toast("Erro ao importar a planilha")
          }
        }
      }
    })
  }

  return (
    <Modal isOpen={!!config} onClosed={onClosed} size="lg">
      <ModalBody>
        <h2>Importar Ordens de Serviço</h2>
        <hr />
        {config && (
          <>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-8 field">
                  <label htmlFor="cnpj">Planilha</label>
                  <CustomDropzone
                    value={data.planilha}
                    onChange={value => handleChange('planilha', value)}
                    onRemove={() => handleChange('planilha', null)}
                    edit={true}
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12">
                  <Button color="primary" type="submit" disabled={!data.planilha}>Importar</Button>
                  <Button color="primary" onClick={onClosed} outline>Cancelar</Button>
                </div>
              </div>
            </form>
          </>
        )}

      </ModalBody>
    </Modal>
  )
}